/**
 * Utility de logging que remove logs em produção
 * Mantém apenas erros críticos para debugging
 */

type LogLevel = 'log' | 'warn' | 'error' | 'debug';

const isDevelopment = import.meta.env.DEV || import.meta.env.MODE === 'development';

class Logger {
  private shouldLog(level: LogLevel): boolean {
    // Sempre logar erros, mesmo em produção
    if (level === 'error') return true;
    // Logs de debug apenas em desenvolvimento
    if (level === 'debug') return isDevelopment;
    // Logs normais apenas em desenvolvimento
    return isDevelopment;
  }

  log(...args: any[]): void {
    if (this.shouldLog('log')) {
      console.log('[LOG]', ...args);
    }
  }

  warn(...args: any[]): void {
    if (this.shouldLog('warn')) {
      console.warn('[WARN]', ...args);
    }
  }

  error(...args: any[]): void {
    // Sempre logar erros
    console.error('[ERROR]', ...args);
  }

  debug(...args: any[]): void {
    if (this.shouldLog('debug')) {
      console.debug('[DEBUG]', ...args);
    }
  }

  // Método para logar erros de forma estruturada
  errorWithContext(message: string, error: Error | unknown, context?: Record<string, any>): void {
    const errorObj = error instanceof Error ? {
      message: error.message,
      stack: error.stack,
      name: error.name,
    } : { error };

    console.error('[ERROR]', message, {
      ...errorObj,
      ...context,
      timestamp: new Date().toISOString(),
    });
  }
}

export const logger = new Logger();

